// Types
import type { TBadgeColor, TBadgeProps, TBadgeSize } from './Badge.type';

export const BADGE_COLORS: TBadgeColor[] = ['primary', 'secondary', 'tertiary', 'information', 'success', 'warning', 'error']
export const BADGE_COLOR: { [key in TBadgeColor]: key } = {
	primary: 'primary',
	secondary: 'secondary',
	tertiary: 'tertiary',
	information: 'information',
	success: 'success',
	warning: 'warning',
	error: 'error'
}

export const BADGE_SIZE: { [key in TBadgeSize]: key } = {
	sm: 'sm',
	md: 'md',
	lg: 'lg'
}

export const BADGE_DEFAULT_PROPS: TBadgeProps = {
	color: BADGE_COLOR.primary,
	size: BADGE_SIZE.md
}
